export function resolveMedia(mp) {
  if (!mp) return null;

  let path = Array.isArray(mp) ? mp[0] : mp;
  
  if (typeof path === 'object' && path !== null) {
    path = path.url || path.path || path.photoUrl || null;
  }
  
  path = String(path || '').trim();
  
  if (!path) return null;
  
  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  if (/^[A-Za-z0-9.-]+\.[A-Za-z]{2,}(\/.*)?$/i.test(path)) {
    return `https://${path}`;
  }
  
  const base =
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_MEDIA_BASE_URL ||
    '';
  
  if (!base) {
    return path.startsWith('/') ? path : `/${path}`;
  }
  
  const cleanBase = String(base).replace(/\/$/, '');
  const cleanPath = String(path).replace(/^\//, '');
  
  return `${cleanBase}/${cleanPath}`;
}
